
const $config = {
  //'feathersServer': "http://localhost:3030",
  //'feathersServer': "http://192.168.0.11:3030",
  //'uploadServer': "http://localhost:3030/upload"
  //'feathersServer': "207.154.229.158:3030",
  //'uploadServer': "167.99.244.170/upload"
  'feathersServer': "https://api.livecasthq.com",
  //'feathersServer': "http://localhost:3030",
  'uploadServer': "api.livecasthq.com/upload"
}

export default $config;
